import { render, staticRenderFns } from "./MediaFiles.vue?vue&type=template&id=cebd433a&scoped=true"
import script from "./MediaFiles.vue?vue&type=script&lang=js"
export * from "./MediaFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebd433a",
  null
  
)

export default component.exports